import '../assets/NcTextArea-DitXCroY.css';
import { G as s } from "../chunks/GenRandomId-BW3iYFf9.mjs";
import { A as r } from "../chunks/AlertCircleOutline-U_bhL30C.mjs";
import { C as l } from "../chunks/Check-CRLmJNGG.mjs";
import { n as i } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const n = {
  name: "NcTextArea",
  components: {
    AlertCircle: r,
    Check: l
  },
  inheritAttrs: !1,
  props: {
    /**
     * The value of the input field
     */
    value: {
      type: String,
      required: !0
    },
    /**
     * The input label, always provide one for accessibility purposes.
     * This will also be used as a placeholder unless the placeholder
     * prop is populated with a different string.
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Pass in true if you want to use an external label. This is useful
     * if you need a label that looks different from the one provided by
     * this component
     */
    labelOutside: {
      type: Boolean,
      default: !1
    },
    /**
     * The placeholder of the input. This defaults as the string that's
     * passed into the label prop. In order to remove the placeholder,
     * pass in an empty string.
     */
    placeholder: {
      type: String,
      default: void 0
    },
    /**
     * Toggles the success state of the component. Adds a checkmark icon.
     * this cannot be used together with canClear.
     */
    success: {
      type: Boolean,
      default: !1
    },
    /**
     * Toggles the error state of the component. Adds an error icon.
     * this cannot be used together with canClear.
     */
    error: {
      type: Boolean,
      default: !1
    },
    /**
     * Additional helper text message
     *
     * This will be displayed beneath the input field. In case the field is
     * also marked as having an error, the text will be displayed in red.
     */
    helperText: {
      type: String,
      default: ""
    },
    /**
     * Disable the input field
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Class to add to the input field.
     * Necessary to use NcInputField in the NcActionInput component.
     */
    inputClass: {
      type: [Object, String],
      default: ""
    },
    /**
     * The resize CSS property sets whether an element is resizable, and if
     * so, in which directions.
     */
    resize: {
      type: String,
      default: "both",
      validator: (t) => ["both", "vertical", "horizontal", "none"].includes(t)
    }
  },
  emits: [
    "update:value"
  ],
  computed: {
    computedId() {
      return this.$attrs.id && this.$attrs.id !== "" ? this.$attrs.id : this.inputName;
    },
    inputName() {
      return "input" + s();
    },
    hasPlaceholder() {
      return this.placeholder !== "" && this.placeholder !== void 0;
    },
    computedPlaceholder() {
      return this.hasPlaceholder ? this.placeholder : this.label;
    },
    isValidLabel() {
      const t = this.label || this.labelOutside;
      return t || console.warn("You need to add a label to the NcInputField component. Either use the prop label or use an external one, as per the example in the documentation."), t;
    },
    ariaDescribedby() {
      const t = [];
      return this.helperText.length > 0 && t.push("".concat(this.inputName, "-helper-text")), this.$attrs["aria-describedby"] && t.push(this.$attrs["aria-describedby"]), t.join(" ") || null;
    }
  },
  methods: {
    /**
     * Focus the input element
     *
     * @public
     */
    focus() {
      this.$refs.input.focus();
    },
    /**
     * Select all the text in the input
     *
     * @public
     */
    select() {
      this.$refs.input.select();
    },
    handleInput(t) {
      this.$emit("update:value", t.target.value);
    }
  }
};
var d = function() {
  var e = this, a = e._self._c;
  return a("div", { staticClass: "textarea", class: { "textarea--disabled": e.disabled } }, [a("div", { staticClass: "textarea__main-wrapper" }, [a("textarea", e._g(e._b({ ref: "input", staticClass: "textarea__input", class: [
    e.inputClass,
    {
      "textarea__input--label-outside": e.labelOutside,
      "textarea__input--success": e.success,
      "textarea__input--error": e.error
    }
  ], style: { resize: e.resize }, attrs: { id: e.computedId, type: e.type, disabled: e.disabled, placeholder: e.computedPlaceholder, "aria-describedby": e.ariaDescribedby, "aria-live": "polite" }, domProps: { value: e.value }, on: { input: e.handleInput } }, "textarea", e.$attrs, !1), e.$listeners)), e._v(" "), !e.labelOutside && e.isValidLabel ? a("label", { staticClass: "textarea__label", attrs: { for: e.computedId } }, [e._v(" " + e._s(e.label) + " ")]) : e._e()]), e.helperText.length > 0 ? a("p", { staticClass: "textarea__helper-text-message", class: {
    "textarea__helper-text-message--error": e.error,
    "textarea__helper-text-message--success": e.success
  }, attrs: { id: "".concat(e.inputName, "-helper-text") } }, [e.success ? a("Check", { staticClass: "textarea__helper-text-message__icon", attrs: { size: 18 } }) : e.error ? a("AlertCircle", { staticClass: "textarea__helper-text-message__icon", attrs: { size: 18 } }) : e._e(), e._v(" " + e._s(e.helperText) + " ")], 1) : e._e()]);
}, o = [], u = /* @__PURE__ */ i(
  n,
  d,
  o,
  !1,
  null,
  "219a1ffb",
  null,
  null
);
const f = u.exports;
export {
  f as default
};
